/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export const GUAM = 'GU';
export const MARIANA_ISLANDS = 'MP';
export const PUERTO_RICO = 'PR';
export const VIRGIN_ISLANDS = 'VI';
export const states = [{
  text: 'AL',
  value: 'AL'
}, {
  text: 'AK',
  value: 'AK'
}, {
  text: 'AZ',
  value: 'AZ'
}, {
  text: 'AR',
  value: 'AR'
}, {
  text: 'CA',
  value: 'CA'
}, {
  text: 'CO',
  value: 'CO'
}, {
  text: 'CT',
  value: 'CT'
}, {
  text: 'D.C.',
  value: 'DC'
}, {
  text: 'DE',
  value: 'DE'
}, {
  text: 'FL',
  value: 'FL'
}, {
  text: 'GA',
  value: 'GA'
}, {
  text: 'GU',
  value: 'GU'
}, {
  text: 'HI',
  value: 'HI'
}, {
  text: 'ID',
  value: 'ID'
}, {
  text: 'IL',
  value: 'IL'
}, {
  text: 'IN',
  value: 'IN'
}, {
  text: 'IA',
  value: 'IA'
}, {
  text: 'KS',
  value: 'KS'
}, {
  text: 'KY',
  value: 'KY'
}, {
  text: 'LA',
  value: 'LA'
}, {
  text: 'ME',
  value: 'ME'
}, {
  text: 'MD',
  value: 'MD'
}, {
  text: 'MA',
  value: 'MA'
}, {
  text: 'MI',
  value: 'MI'
}, {
  text: 'MN',
  value: 'MN'
}, {
  text: 'MP',
  value: 'MP'
}, {
  text: 'MS',
  value: 'MS'
}, {
  text: 'MO',
  value: 'MO'
}, {
  text: 'MT',
  value: 'MT'
}, {
  text: 'NE',
  value: 'NE'
}, {
  text: 'NV',
  value: 'NV'
}, {
  text: 'NH',
  value: 'NH'
}, {
  text: 'NJ',
  value: 'NJ'
}, {
  text: 'NM',
  value: 'NM'
}, {
  text: 'NY',
  value: 'NY'
}, {
  text: 'NC',
  value: 'NC'
}, {
  text: 'ND',
  value: 'ND'
}, {
  text: 'OH',
  value: 'OH'
}, {
  text: 'OK',
  value: 'OK'
}, {
  text: 'OR',
  value: 'OR'
}, {
  text: 'PA',
  value: 'PA'
}, {
  text: 'PR',
  value: 'PR'
}, {
  text: 'RI',
  value: 'RI'
}, {
  text: 'SC',
  value: 'SC'
}, {
  text: 'SD',
  value: 'SD'
}, {
  text: 'TN',
  value: 'TN'
}, {
  text: 'TX',
  value: 'TX'
}, {
  text: 'UT',
  value: 'UT'
}, {
  text: 'VT',
  value: 'VT'
}, {
  text: 'VA',
  value: 'VA'
}, {
  text: 'VI',
  value: 'VI'
}, {
  text: 'WA',
  value: 'WA'
}, {
  text: 'WI',
  value: 'WI'
}, {
  text: 'WV',
  value: 'WV'
}, {
  text: 'WY',
  value: 'WY'
}];